import { QRCodeCanvas } from "qrcode.react";
import { Copy, Download, X } from "lucide-react";
import { toast } from "sonner";

export const signupUrl = (slug) => `${window.location.origin}/e/${slug}`;

// Big QR code guests scan at your table to sign up on their own phone.
export const EventQrPanel = ({ event, onClose }) => {
  const url = signupUrl(event.slug);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch {
      toast.error("Couldn't copy — long-press the link instead.");
    }
  };
  const download = () => {
    const canvas = document.getElementById("event-qr-canvas");
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `${event.slug}-qr.png`;
    a.click();
  };
  return (
    <div data-testid="event-qr-panel" className="fixed inset-0 z-50 bg-white overflow-y-auto">
      <div className="max-w-md mx-auto px-5 pt-5 pb-10 flex flex-col items-center text-center">
        <button type="button" onClick={onClose} data-testid="event-qr-close" className="self-end p-2 rounded-full bg-brand-cream" aria-label="Close">
          <X className="h-5 w-5" />
        </button>
        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-teal">Scan to sign up</p>
        <h2 className="mt-2 font-display font-black text-3xl text-brand-charcoal">{event.name}</h2>
        <div className="mt-6 p-5 rounded-3xl bg-white border border-black/10 shadow-xl">
          <QRCodeCanvas id="event-qr-canvas" value={url} size={280} level="M" includeMargin data-testid="event-qr-code" />
        </div>
        <p data-testid="event-qr-url" className="mt-4 text-[13px] text-brand-charcoal/70 break-all">{url}</p>
        {!event.signup_open && (
          <p className="mt-2 text-[12px] font-bold text-red-600">Sign-ups are closed — reopen them on the event page.</p>
        )}
        <div className="mt-6 grid grid-cols-2 gap-2 w-full">
          <button type="button" onClick={copy} data-testid="event-qr-copy" className="h-12 rounded-full border border-black/15 font-bold text-[12px] uppercase tracking-[0.1em] inline-flex items-center justify-center gap-2">
            <Copy className="h-4 w-4" /> Copy link
          </button>
          <button type="button" onClick={download} data-testid="event-qr-download" className="h-12 rounded-full bg-brand-charcoal text-white font-bold text-[12px] uppercase tracking-[0.1em] inline-flex items-center justify-center gap-2">
            <Download className="h-4 w-4" /> Save QR
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventQrPanel;
